import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Brain, Flame, CheckCircle2, ShieldCheck, ArrowRight, GraduationCap, Bot, Users, PhoneCall } from 'lucide-react';
import { CountdownTimer } from '../components/CountdownTimer';
import { BonusCard } from '../components/BonusCard';
import { TestimonialSection } from '../components/TestimonialSection';
import { Footer } from '../components/Footer';
import { FAQ } from '../components/FAQ';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
export function ReplayOfferPage() {
  const fadeIn = {
    initial: {
      opacity: 0,
      y: 20
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true
    },
    transition: {
      duration: 0.6
    }
  };
  return <div className="min-h-screen bg-slate-50 font-sans selection:bg-cyan-500/30" data-id="element-2048">
      {/* 1. Urgency Bar */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-red-600 overflow-hidden whitespace-nowrap shadow-md" data-id="element-2049">
        <div className="inline-block animate-marquee py-2 text-white text-sm md:text-base font-bold tracking-wide" data-id="element-2050">
          <span className="mx-8" data-id="element-2051">
            ⚠️ La grabación de la Masterclass "48 Hrs AI Cash Machine" expira en
            48 horas. No habrá otra oportunidad. ⚠️
          </span>
          <span className="mx-8" data-id="element-2052">
            ⚠️ La grabación de la Masterclass "48 Hrs AI Cash Machine" expira en
            48 horas. No habrá otra oportunidad. ⚠️
          </span>
          <span className="mx-8" data-id="element-2053">
            ⚠️ La grabación de la Masterclass "48 Hrs AI Cash Machine" expira en
            48 horas. No habrá otra oportunidad. ⚠️
          </span>
        </div>
      </div>

      {/* 2. Hero/Headline */}
      <section className="pt-14 pb-8 md:pt-32 md:pb-24 bg-slate-900 text-white relative overflow-hidden" data-id="element-2054">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-cyan-900/20 via-slate-900 to-slate-900" data-id="element-2055"></div>
        <div className="container mx-auto px-4 relative z-10 max-w-5xl text-center" data-id="element-2056">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5
        }} className="inline-block mb-3 md:mb-6" data-id="element-2057">
            <span className="bg-red-500/10 text-red-500 border border-red-500/20 px-4 py-1.5 rounded-full text-sm font-bold tracking-widest uppercase" data-id="element-2058">
              [GRABACIÓN]
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-2xl md:text-5xl lg:text-6xl font-black tracking-tight mb-3 md:mb-6 leading-tight" data-id="element-2059">
            Cómo Lanzar Tu Primer Producto Digital Este Fin de Semana{' '}
            <span className="text-cyan-400 block mt-1 md:mt-2" data-id="element-2060">
              (Aunque No Tengas Idea de Qué Vender)
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="text-base md:text-xl text-slate-300 max-w-3xl mx-auto leading-relaxed mb-6 md:mb-12" data-id="element-2061">
            Acceso por tiempo limitado a la Masterclass en vivo donde Gabriel
            Beltrán te muestra el sistema de IA que elimina la improvisación y
            te dice exactamente qué hacer, en qué orden y qué ignorar para
            lanzar un negocio digital rentable desde cero.
          </motion.p>

          {/* 3. Video Embed */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="relative max-w-4xl mx-auto" data-id="element-2062">
            <div className="relative bg-slate-950 rounded-xl overflow-hidden border border-slate-800" style={{
            boxShadow: '0 0 0 1px rgba(6, 182, 212, 0.3), 0 0 20px rgba(6, 182, 212, 0.2), 0 0 40px rgba(6, 182, 212, 0.1)',
            padding: '56.25% 0 0 0',
            position: 'relative'
          }} data-id="element-2063">
              <iframe src="https://player.vimeo.com/video/1175612091?badge=0&autopause=0&player_id=0&app_id=58479&controls=1" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%'
            }} title="Cómo dejar de improvisar y lanzar un producto digital en 48 horas con un sistema de IA que decide por ti." data-id="element-2064" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.5
        }} className="mt-6 md:mt-10 text-center" data-id="element-2065">
            <a href="#pricing" className="inline-block" data-id="element-2066">
              <button className="bg-gradient-to-r from-cyan-400 to-cyan-500 hover:from-cyan-300 hover:to-cyan-400 text-slate-900 font-black py-3.5 px-10 md:py-4 md:px-14 rounded-xl text-base md:text-lg uppercase tracking-wide shadow-lg shadow-cyan-500/25 hover:shadow-cyan-400/40 transition-all duration-300 flex items-center justify-center gap-2" data-id="element-2067">
                QUIERO ACCEDER AL SISTEMA
                <ArrowRight className="w-5 h-5" data-id="element-2068" />
              </button>
            </a>
          </motion.div>
        </div>
      </section>

      {/* 4. The Problem */}
      <section className="py-10 md:py-20 bg-white" data-id="element-2069">
        <div className="container mx-auto px-4 max-w-5xl" data-id="element-2070">
          <motion.div {...fadeIn} className="text-center mb-8 md:mb-16" data-id="element-2071">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 max-w-3xl mx-auto leading-tight" data-id="element-2072">
              Si te perdiste la masterclass en vivo, probablemente es porque
              estás atrapado en uno de estos dos ciclos:
            </h2>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-4 md:gap-12" data-id="element-2073">
            <motion.div {...fadeIn} transition={{
            delay: 0.1
          }} data-id="element-2074">
              <Card className="h-full p-5 md:p-8 border-slate-200 bg-slate-50 hover:border-cyan-200 transition-colors" data-id="element-2075">
                <div className="w-12 h-12 md:w-14 md:h-14 bg-blue-100 rounded-2xl flex items-center justify-center mb-4 md:mb-6" data-id="element-2076">
                  <Brain className="w-6 h-6 md:w-7 md:h-7 text-blue-600" data-id="element-2077" />
                </div>
                <h3 className="text-lg md:text-xl font-black text-slate-900 mb-3 md:mb-4 uppercase tracking-wide" data-id="element-2078">
                  El Principiante Abrumado
                </h3>
                <p className="text-slate-600 leading-relaxed text-lg" data-id="element-2079">
                  Quieres lanzar algo pero no sabes por dónde empezar. La
                  parálisis por análisis te consume. Ves a otros tener éxito y
                  te preguntas qué estás haciendo mal. El miedo a elegir el
                  nicho o producto equivocado te detiene antes de empezar.
                </p>
              </Card>
            </motion.div>

            <motion.div {...fadeIn} transition={{
            delay: 0.2
          }} data-id="element-2080">
              <Card className="h-full p-5 md:p-8 border-slate-200 bg-slate-50 hover:border-orange-200 transition-colors" data-id="element-2081">
                <div className="w-12 h-12 md:w-14 md:h-14 bg-orange-100 rounded-2xl flex items-center justify-center mb-4 md:mb-6" data-id="element-2082">
                  <Flame className="w-6 h-6 md:w-7 md:h-7 text-orange-600" data-id="element-2083" />
                </div>
                <h3 className="text-lg md:text-xl font-black text-slate-900 mb-3 md:mb-4 uppercase tracking-wide" data-id="element-2084">
                  El Solopreneur Quemado
                </h3>
                <p className="text-slate-600 leading-relaxed text-lg" data-id="element-2085">
                  Ya has invertido en cursos, has probado modelos de negocio y
                  has gastado dinero en anuncios, pero nada es consistente.
                  Estás cansado de las promesas de "6 y 7 cifras" y solo quieres
                  un sistema real que funcione sin depender de la suerte o de un
                  algoritmo.
                </p>
              </Card>
            </motion.div>
          </div>
        </div>
      </section>

      {/* 4.5 Video Carousel - Lo Que Aprenderás a Crear */}
      <section className="py-10 md:py-20 bg-slate-900 text-white overflow-hidden" data-id="element-2086">
        <div className="container mx-auto px-4 max-w-5xl" data-id="element-2087">
          <motion.div {...fadeIn} className="text-center mb-6 md:mb-12" data-id="element-2088">
            <span className="bg-cyan-500/10 text-cyan-400 border border-cyan-500/20 px-4 py-1.5 rounded-full text-sm font-bold tracking-widest uppercase mb-4 inline-block" data-id="element-2089">
              Resultados Reales
            </span>
            <h2 className="text-3xl md:text-5xl font-black text-white mb-4" data-id="element-2090">
              Esto Es Lo Que Aprenderás a Crear
            </h2>
            <p className="text-xl text-slate-400 max-w-2xl mx-auto" data-id="element-2091">
              Videos, contenido y productos digitales creados con el sistema —
              desliza para ver más →
            </p>
          </motion.div>
        </div>

        <motion.div {...fadeIn} data-id="element-2092">
          <div className="flex gap-6 overflow-x-auto snap-x snap-mandatory pb-6 px-4 md:px-8 scrollbar-hide" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }} data-id="element-2093">
            {/* Spacer for centering on large screens */}
            <div className="flex-shrink-0 w-0 md:w-[calc((100vw-1000px)/2)]" data-id="element-2094" />

            {/* Video 1 - UGC Vertical (9:16) */}
            <div className="flex-shrink-0 w-[65vw] md:w-[300px] snap-center" data-id="element-2095">
              <div className="bg-slate-800 rounded-2xl overflow-hidden border border-slate-700 shadow-xl" data-id="element-2096">
                <div style={{
                padding: '177.78% 0 0 0',
                position: 'relative'
              }} data-id="element-2097">
                  <iframe src="https://player.vimeo.com/video/1168644203?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="36 UGC" data-id="element-2098" />
                </div>
                <div className="p-4" data-id="element-2099">
                  <p className="text-sm font-semibold text-slate-300" data-id="element-2100">
                    UGC Creado con IA
                  </p>
                </div>
              </div>
            </div>

            {/* Video 2 - Vertical (9:16) */}
            <div className="flex-shrink-0 w-[65vw] md:w-[300px] snap-center" data-id="element-2101">
              <div className="bg-slate-800 rounded-2xl overflow-hidden border border-slate-700 shadow-xl" data-id="element-2102">
                <div style={{
                padding: '177.78% 0 0 0',
                position: 'relative'
              }} data-id="element-2103">
                  <iframe src="https://player.vimeo.com/video/1164458576?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="REEL 4 READY TO PLAY 4 SP" data-id="element-2104" />
                </div>
                <div className="p-4" data-id="element-2105">
                  <p className="text-sm font-semibold text-slate-300" data-id="element-2106">
                    Reel Creado con IA
                  </p>
                </div>
              </div>
            </div>

            {/* Video 3 - Vertical (9:16) */}
            <div className="flex-shrink-0 w-[65vw] md:w-[300px] snap-center" data-id="element-2107">
              <div className="bg-slate-800 rounded-2xl overflow-hidden border border-slate-700 shadow-xl" data-id="element-2108">
                <div style={{
                padding: '177.78% 0 0 0',
                position: 'relative'
              }} data-id="element-2109">
                  <iframe src="https://player.vimeo.com/video/1168633813?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="BACKYARD PIT MASTER" data-id="element-2110" />
                </div>
                <div className="p-4" data-id="element-2111">
                  <p className="text-sm font-semibold text-slate-300" data-id="element-2112">
                    Contenido Viral con IA
                  </p>
                </div>
              </div>
            </div>

            {/* Spacer for centering on large screens */}
            <div className="flex-shrink-0 w-4 md:w-[calc((100vw-1100px)/2)]" data-id="element-2113" />
          </div>
        </motion.div>
      </section>

      {/* 5. The Offer */}
      <section className="py-10 md:py-20 bg-slate-900 text-white relative" data-id="element-2114">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5" data-id="element-2115"></div>
        <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-2116">
          <motion.div {...fadeIn} className="text-center mb-8 md:mb-12" data-id="element-2117">
            <h2 className="text-3xl md:text-5xl font-black text-white mb-6 leading-tight" data-id="element-2118">
              Activa el Sistema "48 Hrs AI Cash Machine" Hoy y Deja que la IA
              Decida por Ti
            </h2>
            <p className="text-xl text-slate-300 leading-relaxed" data-id="element-2119">
              La decisión real no es si esto funciona. Es si seguirás decidiendo
              solo o dejarás que un sistema decida contigo. El programa "48 Hrs
              AI Cash Machine" no es más información. Es un sistema de ejecución
              que te guía paso a paso para que lances tu primer (o próximo)
              producto digital en un fin de semana.
            </p>
          </motion.div>

          <motion.div {...fadeIn} className="bg-slate-800/50 border border-slate-700 rounded-2xl p-8 md:p-12 backdrop-blur-sm" data-id="element-2120">
            <h3 className="text-2xl font-bold text-cyan-400 mb-8 text-center uppercase tracking-wider" data-id="element-2121">
              Qué Incluye El Sistema:
            </h3>

            <ul className="space-y-6 mb-10" data-id="element-2122">
              {[{
              text: "Acceso al curso '48 Hrs AI Cash Machine' de por vida",
              value: '$2,997'
            }, {
              text: 'Las 8 Fases del Sistema de Lanzamiento con IA',
              value: '$1,997'
            }, {
              text: 'Comunidad Privada de Soporte 24/7',
              value: '$997'
            }, {
              text: '1 Llamada de Implementación en Vivo con Gabriel Beltrán al mes',
              value: '$1,500'
            }, {
              text: '1 Llamada de Coaching en Vivo con un Coach al mes',
              value: '$1,500'
            }].map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-2123">
                  <CheckCircle2 className="w-6 h-6 text-cyan-500 flex-shrink-0 mt-1" data-id="element-2124" />
                  <div data-id="element-2125">
                    <span className="text-lg md:text-xl font-medium text-white block" data-id="element-2126">
                      {item.text}
                    </span>
                    <span className="text-cyan-400/80 text-sm font-bold" data-id="element-2127">
                      Valor: {item.value}
                    </span>
                  </div>
                </li>)}
            </ul>

            <div className="pt-8 border-t border-slate-700 text-center" data-id="element-2128">
              <p className="text-slate-400 text-lg mb-2 uppercase tracking-widest font-bold" data-id="element-2129">
                Valor Total del Sistema
              </p>
              <p className="text-4xl md:text-6xl font-black text-white line-through opacity-50 decoration-red-500" data-id="element-2130">
                $11,476
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* 6. Bonuses */}
      <section className="py-10 md:py-20 bg-slate-50" data-id="element-2131">
        <div className="container mx-auto px-4 max-w-5xl" data-id="element-2132">
          <motion.div {...fadeIn} className="text-center mb-8 md:mb-16" data-id="element-2133">
            <span className="bg-green-100 text-green-800 px-4 py-1.5 rounded-full text-sm font-bold tracking-widest uppercase mb-4 inline-block" data-id="element-2134">
              Solo Disponibles Con La Grabación
            </span>
            <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-4" data-id="element-2135">
              Bonos de Acción Rápida
            </h2>
            <p className="text-xl text-slate-600" data-id="element-2136">
              Herramientas exclusivas de IA para acelerar tus resultados.
            </p>
          </motion.div>

          <div className="space-y-4 md:space-y-8" data-id="element-2137">
            <motion.div {...fadeIn} data-id="element-2138">
              <BonusCard bonusNumber={1} title="AI Product Builder" description="Tu asistente completo para crear productos digitales desde cero. HeyLloyd te guía en cada paso: desde la idea inicial hasta el lanzamiento." features={['Valor: $497', 'Incluido GRATIS hoy']} imageSrc="https://cdn.magicpatterns.com/uploads/pXDmn28qLnCMrUYkdpGPpS/hf_20260116_225721_4dc7f3c1-48e8-4206-b7a5-3ddf70d36f02.png" data-id="element-2139" />
            </motion.div>

            <motion.div {...fadeIn} data-id="element-2140">
              <BonusCard bonusNumber={2} title="Ebook Writer & Cover Designer" description="Perfecto para crear ebooks completos desde cero y diseñar portadas profesionales que atraen lectores." features={['Valor: $497', 'Incluido GRATIS hoy']} imageSrc="https://cdn.magicpatterns.com/uploads/mZHQRarDkUFPHSnnRgrYNx/heylloyd-image-1768596398723.png" data-id="element-2141" />
            </motion.div>

            <motion.div {...fadeIn} data-id="element-2142">
              <BonusCard bonusNumber={3} title="Meta Ads Decision Engine" description="Motor de decisiones para tus campañas. Analiza, optimiza y toma decisiones estratégicas sobre tus anuncios en tiempo real." features={['Valor: $997', 'Incluido GRATIS hoy']} imageSrc="https://cdn.magicpatterns.com/uploads/uX7GKZjLzcZHYruWJanCH7/heylloyd-image-1768596648758.png" data-id="element-2143" />
            </motion.div>

            <motion.div {...fadeIn} data-id="element-2144">
              <BonusCard bonusNumber={4} title="Sales Letter Weapon & Identity Persuasion Copywriter" description="Tu arma secreta para crear cartas de ventas que convierten y copy persuasivo que conecta con la identidad de tu audiencia." features={['Valor: $997', 'Incluido GRATIS hoy']} imageSrc="https://cdn.magicpatterns.com/uploads/5Vbgxv8pJwQBoVv72Jwat3/heylloyd-image-1768596561791.png" data-id="element-2145" />
            </motion.div>

            <motion.div {...fadeIn} data-id="element-2146">
              <BonusCard bonusNumber={5} title="The Viral PDF Lab" description="Laboratorio especializado en crear PDFs que se comparten masivamente. Ideal para lead magnets y recursos descargables." features={['Valor: $497', 'Incluido GRATIS hoy']} imageSrc="https://cdn.magicpatterns.com/uploads/wRK7DAN3h4pP5mk1SskSzS/heylloyd-image-1768596692126.png" data-id="element-2147" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* 7. Testimonials */}
      <section className="py-10 md:py-20 bg-white border-t border-slate-100" data-id="element-2148">
        <div className="container mx-auto px-4" data-id="element-2149">
          <motion.div {...fadeIn} data-id="element-2150">
            <TestimonialSection data-id="element-2151" />
          </motion.div>
        </div>
      </section>

      {/* 7.5 Mobile-Only Screenshot Testimonials */}
      <section className="py-8 bg-slate-900 md:hidden" data-id="element-2152">
        <div className="px-4" data-id="element-2153">
          <motion.div {...fadeIn} className="text-center mb-6" data-id="element-2154">
            <span className="bg-cyan-500/10 text-cyan-400 border border-cyan-500/20 px-4 py-1.5 rounded-full text-xs font-bold tracking-widest uppercase" data-id="element-2155">
              Resultados de la Comunidad
            </span>
          </motion.div>
          <div className="space-y-4" data-id="element-2156">
            {['https://cdn.magicpatterns.com/uploads/6hDRsi8geoyBo1LuTkW1VC/1.png', 'https://cdn.magicpatterns.com/uploads/jBgTZy1aGZp3HXsx6V1XFc/2.png', 'https://cdn.magicpatterns.com/uploads/9SvJ47R5DxiQD9fcm6e3iP/3.png', 'https://cdn.magicpatterns.com/uploads/pLaiYtszVfzAtTQgTPmXP5/4.png', 'https://cdn.magicpatterns.com/uploads/edMRnj3do87UGZUb3vBuUJ/5.png', 'https://cdn.magicpatterns.com/uploads/qfNfNLiDXsWz23HitwxznD/6.png', 'https://cdn.magicpatterns.com/uploads/9394kMK1jJMHkXQoyyXkjr/7.png', 'https://cdn.magicpatterns.com/uploads/2WbYgSsRnKA1qq61jawuZh/8.png'].map((src, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.08
          }} className="relative rounded-xl overflow-hidden border border-cyan-500/10" data-id="element-2157">
                <img src={src} alt={`Testimonio ${i + 1}`} className="w-full h-auto block" loading="lazy" data-id="element-2158" />
                {/* Branded cyan tint overlay */}
                <div className="absolute inset-0 bg-gradient-to-b from-cyan-500/[0.06] via-transparent to-cyan-900/[0.12] pointer-events-none" data-id="element-2159" />
                <div className="absolute inset-0 mix-blend-color bg-cyan-500/[0.04] pointer-events-none" data-id="element-2160" />
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* 8. Final CTA & Pricing */}
      <section id="pricing" className="py-12 md:py-24 bg-slate-900 text-white relative overflow-hidden scroll-mt-12" data-id="element-2161">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,_var(--tw-gradient-stops))] from-cyan-900/20 via-slate-900 to-slate-900" data-id="element-2162"></div>
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-cyan-500/5 rounded-full blur-3xl" data-id="element-2163"></div>
        <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-2164">
          <motion.div {...fadeIn} className="text-center mb-6" data-id="element-2165">
            <span className="inline-block bg-red-500/10 text-red-400 border border-red-500/20 px-5 py-2 rounded-full text-sm font-bold tracking-widest uppercase mb-6" data-id="element-2166">
              ⏰ Oferta por Tiempo Limitado
            </span>
            <h2 className="text-3xl md:text-5xl font-black text-white leading-tight max-w-4xl mx-auto mb-4" data-id="element-2167">
              Accede al Sistema Completo por Menos de lo que Cuesta un Curso que
              No Vas a Terminar
            </h2>
            <p className="text-lg text-slate-400 max-w-2xl mx-auto" data-id="element-2168">
              Todo lo que necesitas para lanzar tu producto digital este fin de
              semana — en un solo paquete.
            </p>
          </motion.div>

          {/* Product Image with glow */}
          <motion.div {...fadeIn} className="relative max-w-3xl mx-auto mb-8" data-id="element-2169">
            <div className="absolute inset-0 bg-cyan-500/8 blur-[80px] rounded-full scale-90" data-id="element-2170"></div>
            <div className="absolute -inset-4 bg-gradient-to-b from-cyan-500/5 to-transparent rounded-3xl" data-id="element-2171"></div>
          </motion.div>

          {/* Price Anchor */}
          <motion.div {...fadeIn} className="text-center mb-12" data-id="element-2172">
            <p className="text-slate-500 text-lg mb-1" data-id="element-2173">
              Valor total del sistema + bonos:
            </p>
            <p className="text-3xl md:text-4xl font-black text-slate-500 line-through decoration-red-500/70 decoration-2" data-id="element-2174">
              $11,476 USD
            </p>
            <p className="text-cyan-400 text-xl font-bold mt-3" data-id="element-2175">
              Hoy accedes por una fracción:
            </p>
          </motion.div>

          {/* Pricing Cards */}
          <div className="grid md:grid-cols-2 gap-6 md:gap-8 max-w-3xl mx-auto mb-12" data-id="element-2176">
            {/* Pricing Option 1 - Best Value */}
            <motion.div {...fadeIn} transition={{
            delay: 0.1
          }} data-id="element-2177">
              <div className="relative h-full" data-id="element-2178">
                {/* Glow border effect */}
                <div className="absolute -inset-[1px] bg-gradient-to-b from-cyan-400 via-cyan-500/50 to-cyan-400/20 rounded-2xl" data-id="element-2179"></div>
                <div className="relative h-full bg-slate-900 rounded-2xl p-8 flex flex-col" data-id="element-2180">
                  <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gradient-to-r from-cyan-400 to-cyan-500 text-slate-900 text-xs font-black px-6 py-1.5 rounded-full uppercase tracking-widest shadow-lg shadow-cyan-500/30" data-id="element-2181">
                    ⭐ Mejor Valor
                  </div>
                  <h3 className="text-xl font-bold text-white mb-1 mt-2" data-id="element-2182">
                    PAGO ÚNICO
                  </h3>
                  <p className="text-slate-400 text-sm mb-6" data-id="element-2183">
                    Acceso inmediato y de por vida
                  </p>

                  <div className="mb-2" data-id="element-2184">
                    <span className="text-sm text-slate-500 line-through" data-id="element-2185">
                      $11,476
                    </span>
                  </div>
                  <div className="flex items-baseline gap-2 mb-2" data-id="element-2186">
                    <span className="text-6xl font-black text-cyan-400" data-id="element-2187">
                      $297
                    </span>
                    <span className="text-slate-500 text-lg" data-id="element-2188">USD</span>
                  </div>
                  <p className="text-emerald-400 text-sm font-semibold mb-8" data-id="element-2189">
                    Ahorras $11,179 — 97% de descuento
                  </p>

                  <div className="mt-auto" data-id="element-2190">
                    <a href="https://www.fanbasis.com/agency-checkout/true-marketer/wKOVJ" className="block w-full" data-id="element-2191">
                      <button className="w-full bg-gradient-to-r from-cyan-400 to-cyan-500 hover:from-cyan-300 hover:to-cyan-400 text-slate-900 font-black py-4 px-6 rounded-xl text-lg uppercase tracking-wide shadow-lg shadow-cyan-500/25 hover:shadow-cyan-400/40 transition-all duration-300 flex items-center justify-center gap-2" data-id="element-2192">
                        COMPRAR AHORA
                        <ArrowRight className="w-5 h-5" data-id="element-2193" />
                      </button>
                    </a>
                    <p className="text-center text-slate-500 text-xs mt-3" data-id="element-2194">
                      🔒 Pago seguro • Acceso instantáneo
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Pricing Option 2 - Payment Plan */}
            <motion.div {...fadeIn} transition={{
            delay: 0.2
          }} data-id="element-2195">
              <div className="relative h-full border border-slate-700 rounded-2xl bg-slate-800/40 backdrop-blur-sm p-8 flex flex-col hover:border-slate-600 transition-all duration-300" data-id="element-2196">
                <h3 className="text-xl font-bold text-white mb-1" data-id="element-2197">
                  PLAN DE PAGOS
                </h3>
                <p className="text-slate-400 text-sm mb-6" data-id="element-2198">
                  Con la opción ZIP al momento del checkout (Solo US)
                </p>

                <div className="flex items-baseline gap-1 mb-1" data-id="element-2199">
                  <span className="text-lg text-slate-400" data-id="element-2200">4 pagos de</span>
                </div>
                <div className="flex items-baseline gap-2 mb-2" data-id="element-2201">
                  <span className="text-6xl font-black text-white" data-id="element-2202">
                    $75<span className="text-4xl" data-id="element-2203">.75</span>
                  </span>
                  <span className="text-slate-500 text-lg" data-id="element-2204">USD</span>
                </div>
                <p className="text-slate-400 text-sm mb-8" data-id="element-2205">
                  Cobrados cada 15 días (Total: $303)
                </p>

                <div className="mt-auto" data-id="element-2206">
                  <a href="https://www.fanbasis.com/agency-checkout/true-marketer/wKOVJ" className="block w-full" data-id="element-2207">
                    <button className="w-full border-2 border-cyan-500/40 hover:border-cyan-400 text-cyan-400 hover:text-cyan-300 font-black py-4 px-6 rounded-xl text-lg uppercase tracking-wide transition-all duration-300 flex items-center justify-center gap-2 hover:bg-cyan-500/5" data-id="element-2208">
                      INICIAR PLAN DE PAGOS
                      <ArrowRight className="w-5 h-5" data-id="element-2209" />
                    </button>
                  </a>
                  <p className="text-center text-slate-500 text-xs mt-3" data-id="element-2210">
                    🔒 Pago seguro • Sin compromiso
                  </p>
                </div>
              </div>
            </motion.div>
          </div>

          {/* What you get summary */}
          <motion.div {...fadeIn} className="max-w-3xl mx-auto mb-12" data-id="element-2211">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center" data-id="element-2212">
              <div className="bg-slate-800/30 border border-slate-700/50 rounded-xl p-5" data-id="element-2213">
                <div className="w-10 h-10 bg-cyan-500/10 rounded-lg flex items-center justify-center mx-auto mb-3" data-id="element-2214">
                  <GraduationCap className="w-5 h-5 text-cyan-400" data-id="element-2215" />
                </div>
                <p className="text-white font-bold text-sm" data-id="element-2216">Curso Completo</p>
                <p className="text-slate-500 text-xs" data-id="element-2217">De por vida</p>
              </div>
              <div className="bg-slate-800/30 border border-slate-700/50 rounded-xl p-5" data-id="element-2218">
                <div className="w-10 h-10 bg-cyan-500/10 rounded-lg flex items-center justify-center mx-auto mb-3" data-id="element-2219">
                  <Bot className="w-5 h-5 text-cyan-400" data-id="element-2220" />
                </div>
                <p className="text-white font-bold text-sm" data-id="element-2221">8 Fases con IA</p>
                <p className="text-slate-500 text-xs" data-id="element-2222">Paso a paso</p>
              </div>
              <div className="bg-slate-800/30 border border-slate-700/50 rounded-xl p-5" data-id="element-2223">
                <div className="w-10 h-10 bg-cyan-500/10 rounded-lg flex items-center justify-center mx-auto mb-3" data-id="element-2224">
                  <Users className="w-5 h-5 text-cyan-400" data-id="element-2225" />
                </div>
                <p className="text-white font-bold text-sm" data-id="element-2226">Comunidad 24/7</p>
                <p className="text-slate-500 text-xs" data-id="element-2227">Soporte real</p>
              </div>
              <div className="bg-slate-800/30 border border-slate-700/50 rounded-xl p-5" data-id="element-2228">
                <div className="w-10 h-10 bg-cyan-500/10 rounded-lg flex items-center justify-center mx-auto mb-3" data-id="element-2229">
                  <PhoneCall className="w-5 h-5 text-cyan-400" data-id="element-2230" />
                </div>
                <p className="text-white font-bold text-sm" data-id="element-2231">2 Llamadas/Mes</p>
                <p className="text-slate-500 text-xs" data-id="element-2232">Con Gabriel</p>
              </div>
            </div>
          </motion.div>

          {/* Guarantee */}
          <motion.div {...fadeIn} className="max-w-3xl mx-auto mb-16" data-id="element-2233">
            <div className="bg-gradient-to-r from-emerald-500/5 via-emerald-500/10 to-emerald-500/5 border border-emerald-500/20 rounded-2xl p-8 flex flex-col md:flex-row items-center gap-6" data-id="element-2234">
              <div className="w-24 h-24 bg-emerald-500/10 rounded-full flex items-center justify-center flex-shrink-0 border border-emerald-500/20" data-id="element-2235">
                <ShieldCheck className="w-12 h-12 text-emerald-400" data-id="element-2236" />
              </div>
              <div className="text-center md:text-left" data-id="element-2237">
                <h4 className="text-2xl font-black text-white mb-2" data-id="element-2238">
                  Garantía Incondicional de 30 Días
                </h4>
                <p className="text-slate-300 leading-relaxed text-lg" data-id="element-2239">
                  Implementa el sistema. Si no es lo que prometí o no te gusta,
                  te devuelvo tu dinero.{' '}
                  <span className="text-emerald-400 font-bold" data-id="element-2240">
                    Sin preguntas. Sin letra pequeña.
                  </span>{' '}
                  Tienes un mes entero para probarlo sin riesgo.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Final Urgency & Timer */}
          <motion.div {...fadeIn} className="text-center max-w-2xl mx-auto" data-id="element-2241">
            <div className="bg-red-500/5 border border-red-500/20 rounded-2xl p-8" data-id="element-2242">
              <p className="text-red-400 font-bold text-xl mb-6" data-id="element-2243">
                ⚠️ Esta página y la oferta desaparecerán cuando el contador
                llegue a cero.
              </p>
              <p className="text-slate-400 mb-6" data-id="element-2244">
                Esta es tu última oportunidad de acceder a este precio.
              </p>
              <div className="bg-slate-950/50 p-6 rounded-2xl border border-slate-800 inline-block mb-6" data-id="element-2245">
                <CountdownTimer data-id="element-2246" />
              </div>
              <div className="pt-4" data-id="element-2247">
                <a href="https://www.fanbasis.com/agency-checkout/true-marketer/wKOVJ" className="inline-block" data-id="element-2248">
                  <button className="bg-gradient-to-r from-cyan-400 to-cyan-500 hover:from-cyan-300 hover:to-cyan-400 text-slate-900 font-black py-4 px-12 rounded-xl text-lg uppercase tracking-wide shadow-lg shadow-cyan-500/25 hover:shadow-cyan-400/40 transition-all duration-300 flex items-center justify-center gap-2" data-id="element-2249">
                    QUIERO ACCEDER AHORA
                    <ArrowRight className="w-5 h-5" data-id="element-2250" />
                  </button>
                </a>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* 8.5 FAQ */}
      <section className="py-10 md:py-20 bg-white" data-id="element-2251">
        <div className="container mx-auto px-4 max-w-5xl" data-id="element-2252">
          <FAQ data-id="element-2253" />
        </div>
      </section>

      {/* 9. Footer */}
      <Footer data-id="element-2254" />
    </div>;
}